// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import * as Enums from '@/utils/enums';
import Fetch from '@/utils/Fetch';
import BillingService from '@/services/billing-service';
import Helper from '@/utils/helper';
import Router, { useRouter } from 'next/router';
import SubscriptionContext from '@/utils/subscription-context';
import { useQuery } from '@tanstack/react-query';
import ManageQuoteForm from "@/PageComponents/Quote/ManageQuoteForm";
import { createFileRoute } from '@tanstack/react-router'

function CreateQuote() {
  const router = useRouter();
  const { id, module, moduleID, customerID } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

  const subscriptionContext = useContext(SubscriptionContext);
  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  const [hasCreditsAvailable, setHasCreditsAvailable] = useState<any>();

  const { data: copyFromQuote } = useQuery(
    ['quote', id],
    () => Fetch.get({ url: `/Quote/${id}` }),
    { enabled: !!id }
  );

  const { data: company } = useQuery(
    ['company'],
    () => Fetch.get({ url: '/Company' })
  );

  const getAccessStatus = async () => {
    const [subscriptionInfo] = await BillingService.getSubcriptionInfo(subscriptionContext);
    if (subscriptionInfo) {
      setHasCreditsAvailable(subscriptionInfo.SMSCreditsPurchased - (subscriptionInfo.SMSCreditsUsed ? subscriptionInfo.SMSCreditsUsed : 0) > 0);
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  if (!company) return null;
  if (id && !copyFromQuote) return null;

  return (
    <div className="manage-container">
      <ManageQuoteForm
        isNew={true}
        copyFromQuote={copyFromQuote}
        module={module ? +module : undefined}
        moduleID={moduleID}
        customerID={customerID}
        accessStatus={accessStatus}
        company={company}
        mode={'page'}
      />
    </div>
  );
}

export default CreateQuote;

export const Route = createFileRoute('/_authenticated/quote/create')({ component: CreateQuote })
